import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import get from 'lodash/get';
import ArrayHelper from 'foundation/array-helper';
import ScoringLoader, { endpointNames } from 'general/js/loaders/scoring-loader';
import { getPlayerSitecoreData } from 'general/js/helpers';
import { BlockPlaceholder } from 'components/block-placeholder';
import { BlockSpinner } from 'components/block-spinner';
import { stateTypes } from './enums';
import LeaderboardWidget from './leaderboard-widget';
import LeaderboardWidgetAlphaList from './leaderboard-widget-alpha-list';

class LeaderboardWidgetLayout extends React.Component {
    constructor(props) {
        super(props);

        this.players = [];
        this.topPlayersToShowState = true;
        this.numberOfCells = [
            { id: stateTypes.POSITION },
            { id: stateTypes.NAME },
            { id: stateTypes.TEE },
            { id: stateTypes.TO_PAR, textTitle: 'par' },
            { id: stateTypes.HOLE, textTitle: 'hole' },
            { id: stateTypes.TODAY, textTitle: 'today' }
        ];
    }

    componentDidMount() {
        ScoringLoader.subscribe(endpointNames.LIVE_SCANNER);
        ScoringLoader.subscribe(endpointNames.PLAYERS);
        ScoringLoader.subscribe(endpointNames.LEADERBOARD);
    }

    componentWillUnmount() {
        ScoringLoader.unsubscribe(endpointNames.LIVE_SCANNER);
        ScoringLoader.unsubscribe(endpointNames.PLAYERS);
        ScoringLoader.unsubscribe(endpointNames.LEADERBOARD);
    }

    getPlayers = (players) => {
        const { options } = this.props;
        let playersList = [];

        if (!ArrayHelper.isEmpty(options.playerIds)) {
            this.topPlayersToShowState = false;
            playersList = players.filter((player) => (options.playerIds.includes(player.id)));

            return playersList;
        }

        if (ArrayHelper.isEmpty(players)) { return playersList; }

        return players.slice(0, options.topPlayersToShow);
    }

    render() {
        const {
            options,
            liveScanner,
            scoringLeaderboard,
            sitecorePlayers
        } = this.props;

        if (liveScanner === undefined ||
            scoringLeaderboard === undefined ||
            sitecorePlayers === undefined
        ) {
            return (
                <BlockPlaceholder minHeight={300}>
                    <BlockSpinner />
                </BlockPlaceholder>);
        }

        const config = get(liveScanner, 'liveComponents.leaderboard');

        if (!config ||
            (options.type === 'contextual' && !config.ccpShow) ||
            !scoringLeaderboard ||
            !sitecorePlayers
        ) {
            return null;
        }

        if (liveScanner.showAlphaListOnLeaderboardWidget && ArrayHelper.isEmpty(scoringLeaderboard.players)) {
            return <LeaderboardWidgetAlphaList
                options={options}
                players={sitecorePlayers.players}
            />;
        }


        this.players = this.getPlayers(scoringLeaderboard.players);

        return (
            <LeaderboardWidget
                numberOfCells={this.numberOfCells}
                scoringLeaderboard={scoringLeaderboard}
                topPlayersToShowState={this.topPlayersToShowState}
                datePublished={''}
                titleText={this.topPlayersToShowState ? options.topPlayersToShow : options.textOverride}
                players={this.players}
                fullLeaderboardLinkText={options.fullLeaderboardLinkText}
                fullLeaderboardLink={options.fullLeaderboardLink}
                targetsConfig={options.targetsConfig}
                patronLogo ={options.patronLogo}
                liveComponentLeaderboard = {config.show}
                liveComponentSubtitle = {config.subtitle}
            />
        );
    }
}

LeaderboardWidgetLayout.propTypes = {
    options: PropTypes.object
};

const mapStateToProps = (state) => {
    const sitecorePlayers = state.scoring[endpointNames.PLAYERS];
    const scoringLeaderboard = state.scoring[endpointNames.LEADERBOARD];

    if (sitecorePlayers === undefined) return {};

    if (sitecorePlayers &&
        scoringLeaderboard &&
        !ArrayHelper.isEmpty(scoringLeaderboard.players)
    ) {
        scoringLeaderboard.players.forEach((player) => {
            player.sitecoreData = getPlayerSitecoreData(sitecorePlayers, player.id);
        });
    }

    return ({
        liveScanner: state.scoring[endpointNames.LIVE_SCANNER],
        scoringLeaderboard,
        sitecorePlayers,
    });
};

const LeaderboardWidgetLayoutWrapper = connect(
    mapStateToProps,
    null
)(LeaderboardWidgetLayout);

export default LeaderboardWidgetLayoutWrapper;
